var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointXnosvgo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.79,3.571L20.429,8.21L16.639,12L20.429,15.79L15.79,20.429L12,16.639L8.21,20.429L3.571,15.79L7.361,12L3.571,8.21L8.21,3.571L12,7.361Z",
  fill: "currentColor"
})));
export default SvgPointXnosvgo;